import axios from 'axios';

export const Client = axios.create();

/**
 * Whether a failed request should send the browser to the login page: the
 * API refused the session, and we are not on the login page already. The
 * page is told by its path, not the whole address, because Microsoft hands
 * the sign-in back as /login#id_token=...: going to /login from there would
 * throw the sign-in away before it is read.
 */
export const leavesForLogin = (
  status: number | undefined,
  location: Pick<Location, 'pathname'>,
): boolean => status === 401 && location.pathname.replace(/\/+$/, '') !== '/login';

// Intercept 401 and redirect to login page
Client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (leavesForLogin(error.response?.status, window.location)) {
      window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);
